import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Chat } from 'app/layout/common/quick-chat/quick-chat.types';
import { SocketService } from 'app/shared/socket.service';
import { environment } from 'environments/environment';
import { Socket } from 'ngx-socket-io';
import { BehaviorSubject, map, Observable, of, switchMap, tap, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class QuickChatService {
    baseUrl = `${environment.urlBase}chats`;
    private _chat: BehaviorSubject<Chat> = new BehaviorSubject(null);
    private _chats: BehaviorSubject<Chat[]> = new BehaviorSubject<Chat[]>(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private socket: SocketService) {
        this.socket.onMessage('message').subscribe((messageData) => {
            console.log('Received message:', messageData);
            const chat = this._chat.getValue();
            if (chat) {
                chat.messages.push(messageData);
                this._chat.next(chat);
            }else {
                const chats = this._chats.getValue();
                if (chats) {
                    const chatIndex = chats.findIndex((chat) => chat.id === messageData.chatId);
                    if (chatIndex !== -1) {
                        chats[chatIndex].messages.push(messageData);
                        this._chats.next(chats);
                    }
                }
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for chat
     */
    get chat$(): Observable<Chat> {
        return this._chat.asObservable();
    }

    /**
     * Getter for chat
     */
    get chats$(): Observable<Chat[]> {
        return this._chats.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get chats
     */
    getChats(): Observable<any> {
        return this._httpClient.get<Chat[]>(this.baseUrl + '/all').pipe(
            tap((response: Chat[]) => {
                this._chats.next(response);
            }),
        );
    }

    /**
     * Get chat
     *
     * @param id
     */
    getChatById(id: string): Observable<any> {
        return this._httpClient.get<Chat>('api/apps/chat/chat', { params: { id } }).pipe(
            map((chat) => {

                // Update the chat
                this._chat.next(chat);

                // Return the chat
                return chat;
            }),
            switchMap((chat) => {

                if (!chat) {
                    return throwError('Could not found chat with id of ' + id + '!');
                }

                return of(chat);
            }),
        );
    }
    addMessage(message: string): void {
        const chat = this._chat.getValue();
        if (chat) {
            chat.messages.push({
                id: 'message-' + chat.messages.length,
                chatId: chat.id,
                contactId: 'me',
                isMine: true,
                value: message,
                createdAt: new Date().toISOString(),
            });
            this._chat.next(chat);
        }
    }
    sendMessage(message: string, chatId: string): void {
        this.addMessage(message);
        this.socket.sendMessage('message', message, chatId);
    }
}
